module.exports = __webpack_public_path__ + "assets/img/anruyuezi_poster.8dd03da7.png";